import { createAction } from 'redux-actions';

export const getSettingBoothRequested = createAction('GET_SETTING_BOOTH_REQUEST');
export const getSettingBoothReceived = createAction('GET_SETTING_BOOTH_RECEIVED');
export const getSettingBoothReceiveFailure = createAction('GET_SETTING_BOOTH_RECEIVE_FAILURE');
export const getSettingBoothClear = createAction('GET_SETTING_BOOTH_CLEAR');

export const updateSettingBoothRequested = createAction('UPDATE_SETTING_BOOTH_REQUEST');
export const updateSettingBoothReceived = createAction('UPDATE_SETTING_BOOTH_RECEIVED');
export const updateSettingBoothReceiveFailure = createAction('UPDATE_SETTING_BOOTH_RECEIVE_FAILURE');
export const updateSettingBoothClear = createAction('UPDATE_SETTING_BOOTH_CLEAR');
